"use client";

import dayjs from "dayjs";
import tz from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(tz);

/**
 * Display some formatted time localized according to the client side timezone
 */
export function LocalizedTimeText({
	value,
	format,
}: { value: string | Date | null | undefined; format: string }) {
	return value && dayjs(value).isValid()
		? dayjs.utc(value).local().format(format)
		: null;
}
